module.exports = __webpack_public_path__ + "static/0063-081a1ad58be32da83d20b924b24358b9.png";